<template>
  <div class="submit-box" @touchmove.prevent @mousewheel.prevent v-if="showBox">
    <div class="box">
      <div class="container">
        <div class="icon"></div>
        <div class="content">
          <div class="title">{{ title }}</div>
          <div class="desc">{{ desc }}</div>
        </div>
        <div class="btn" @click="confirm">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "submitBox",
  props: {
    showBox: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '提交成功'
    },
    desc: {
      type: String,
      default: '感谢您的反馈，如果您对我们的服务有任何反馈意见，您可以随时上报企业诉求、填写举报投诉。'
    },
  },
  mounted() {
  },
  destroyed() {
    this.move()
  },
  methods: {

    //禁止滚动
    stop() {
      document.body.style.overflow = 'hidden';
      document.addEventListener("touchmove", function (e) {
        e.preventDefault();
      }, false);//禁止页面滑动
    },

    //取消滑动限制
    move() {
      document.body.style.overflow = '';//出现滚动条
      document.removeEventListener("touchmove", function (e) {
        e.preventDefault();
      }, false);
    },

    //确定按钮
    confirm() {
      this.stop()
      this.$emit("confirm");
    }
  }
}
</script>

<style scoped lang="less">
.submit-box {
  z-index: 2020;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  background: rgba(21, 21, 21, 0.7);
  //background: #000000;
  //opacity: 0.69;
  .box {
    display: inline-block;
    vertical-align: middle;
    text-align: left;
    overflow: hidden;
    backface-visibility: hidden;
    margin-top: 50px;
    height: 800px;


    .container {
      width: 577px;
      height: 528px;
      background: linear-gradient(180deg, #FEE7D3 0%, #F8BE86 100%);
      box-shadow: 0px 10px 20px 0px #383838;
      border-radius: 8px;
      opacity: 1;
      margin-top: 130px;
      position: relative;

      .icon {
        width: 320px;
        height: 306px;
        background-image: url("../assets/images/box-icon.png");
        top: -126px;
        left: 50%;
        position: absolute;
        z-index: 2022;
        margin-left: -160px;
      }

      .content {
        width: 450px;
        position: absolute;
        left: 50%;
        margin-left: -225px;
        top: 200px;
        text-align: center;

        .title {
          height: 42px;
          font-size: 30px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          line-height: 42px;
        }

        .desc {
          margin-top: 20px;
          height: 50px;
          font-size: 18px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: #1E1E1E;
          line-height: 25px;
        }
      }

      .btn {
        width: 482px;
        height: 68px;
        background-image: url("../assets/images/box-btn.png");
        background-size: 100% 68px;
        position: absolute;
        bottom: 45px;
        text-align: center;
        line-height: 68px;
        margin-left: -241px;
        left: 50%;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/submitBox.vue